<template>
    <div class='line'  :data-word="apiObj.value"  >
        <div :class="col1Class()">{{ apiObj.value }}</div>
        <div class="col col2">{{ getSetting(apiObj.settingId) }}</div>
        <div class="col col4">{{ apiObj.note }} &nbsp;</div>
        
        <button  class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnCopy" @click='clicCopyAPI()' title="Copier la clé d’API"><i class="material-icons">content_copy</i></button>
        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clicEditAPI()'><i class="material-icons">edit</i></button>
        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicDeleteAPI()'><i class="material-icons">delete</i></button>
    </div>  
</template>

<script>
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'

    export default {
        name:"APILine",
        mixins: [FctUtils],
        props:{
            apiObj: {type:Object},
        },
        data(){
            return {
                settings: {}
            }
        },
        created() {
            // Recuperation des configurations du client
            //
            axios(diagonalbackURL + "/clients/"+ this.$store.getters.currentClientId+"/settings",  defaultConfig)
            .then(reponse => {
                this.settings = reponse.data;
            })
            .catch(error => this.errorHandler(error));
        },
        methods : {
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            col1Class() {
                var result = 'col col1 ';
                result +=  (this.apiObj.active)? 'green' : 'red'
                return result;
            },
            getSetting(settingId) {
                var array = this.settings;

                for (var i = 0; i < array.length; i++) {
                    if (array[i].id == settingId) return array[i].name;
                }

                return "ERROR Configuration non définie"
            }, 
            clicDeleteAPI() {
                this.emitter.emit('showPLForm', {mode:'formAPI_remove', data:this.apiObj});
            },
            clicEditAPI() {
                this.emitter.emit('showPLForm', {mode:'formAPI_edit', data:this.apiObj});
            },
            clicCopyAPI() {
                FctUtils.methods.copyToClipboard(this.apiObj.value)
                alert("Clé copiée !");
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.pl-list .line {
    position:relative;
    width : 100%;
}

.btnEdit {
    position: absolute;
    top: 5px;
    right: 25px;
    color: #0075bb;
}

.btnDelete {
    position: absolute;
    top: 5px;
    right: 5px;
}

.btnCopy {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #0075bb;
}

.btnCopy:has(+ .btnEdit) {
     right: 45px;
}
</style>
